<template>
  <div class="evaluations-accordion">
    <div 
      v-for="(profile, index) in groupedEvaluations" 
      :key="profile.profile_id" 
      class="profile-section border rounded-md shadow mb-4"
    >
      <!-- Perfil Título -->
      <div 
        class="profile-header bg-blue-700 text-white px-4 py-2 cursor-pointer flex justify-between items-center"
        @click="toggleProfile(index)"
      >
        <h2 class="font-bold text-lg">
          {{ profile.profile_name }}
        </h2>
        <button class="toggle-btn">
          <i :class="isActiveProfile(index) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </button>
      </div>
      
      <!-- Evaluaciones -->
      <div v-if="isActiveProfile(index)" class="evaluations-content bg-gray-100 p-4">
        <div 
          v-for="(evaluation, evalIndex) in profile.evaluations" 
          :key="evaluation.id" 
          class="evaluation-section border-b py-4"
        >
          <h3 
            class="font-semibold text-md text-blue-900 cursor-pointer flex justify-between items-center"
            @click="toggleEvaluation(index, evalIndex)"
          >
            <router-link :to="{ name: 'evaluation-fill', params: { evaluation: evaluation } }" 
            class="evaluation-link flex items-center" > {{ traslateType(evaluation.type) }}
            </router-link>
            <button class="toggle-btn">
              <i :class="isActiveEvaluation(index, evalIndex) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
            </button>
          </h3>

          <!-- Competencias -->
          <div 
            v-if="isActiveEvaluation(index, evalIndex)" 
            class="competencies-content mt-2"
          >
            <div 
              v-for="competency in evaluation.competencies" 
              :key="competency.id" 
              class="competency-section mt-3"
            >
              <h4 class="text-sm font-medium text-gray-800">
                {{ competency.name }}
              </h4>

              <!-- Preguntas -->
              <div v-for="question in competency.questions" :key="question.id" class="question-section mt-1 pl-2">
                <p class="text-sm text-gray-600">
                  - {{ question.question_text }}
                </p>

                <!-- Opciones de Respuesta -->
                <ul class="response-options pl-4">
                  <li 
                    v-for="responseOption in evaluation.responseOptions" 
                    :key="responseOption.id"
                    class="text-xs text-gray-500"
                  >
                    • {{ responseOption.description }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupedEvaluations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeProfiles: [],
      activeEvaluations: {}
    };
  },
  methods: {
    traslateType(type) {
      let str = ''
      switch (type) {
        case 'autoevaluation':
            str =  'Autoevaluación'
          break;
        case 'manager_evaluation':
          str =  'Evaluación de Jefe'
          break;
        default:
          str =  'Evaluación General'
          break;
      } 
      return str
    },
    toggleProfile(index) {
      if (this.activeProfiles.includes(index)) {
        this.activeProfiles = this.activeProfiles.filter((i) => i !== index);
      } else {
        this.activeProfiles.push(index);
      }
    },
    isActiveProfile(index) {
      return this.activeProfiles.includes(index);
    },
    toggleEvaluation(profileIndex, evalIndex) {
      if (!this.activeEvaluations[profileIndex]) {
        this.$set(this.activeEvaluations, profileIndex, []);
      }
      const isActive = this.activeEvaluations[profileIndex].includes(evalIndex);
      if (isActive) {
        this.activeEvaluations[profileIndex] = this.activeEvaluations[profileIndex].filter((i) => i !== evalIndex);
      } else {
        this.activeEvaluations[profileIndex].push(evalIndex);
      }
    },
    isActiveEvaluation(profileIndex, evalIndex) {
      return this.activeEvaluations[profileIndex]?.includes(evalIndex) || false;
    }
  }
};
</script>

<style scoped>
*{
  color: #000000;
}
.evaluations-accordion {
  max-width: 90%;
  margin: 0 auto;
}
.profile-section {
  overflow: hidden;
}
.profile-header {
  transition: background-color 0.2s ease-in-out;
}
.profile-header:hover {
  background-color: #3f7e7b;
  h2{
    color: #fff;
  }
}
.evaluations-content {
  background-color: #f9fafb;
}
.toggle-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
.evaluation-section {
  border-color: #d1d5db;
}
</style>
